import { css } from 'lit';

export const q1TutorialListStyles = css`

  :host {
    display: block;
  }

  sl-dialog {
    --width: 1000px;
  }

  button-bar {
    display: flex;
    gap: 0.75rem;
    justify-content: flex-end;
    align-items: center;
  }

  a {
    color: var(--link-color-default, var(--blue-7));
    text-decoration: var(--link-text-decoration-default, underline);
    font-weight: var(--link-font-weight-default, normal);
    transition: all 0.2s ease-in-out;
  }
  a:visited {
    color: var(--link-color-visited, var(--blue-8));
  }
  a:focus, a:hover {
    color: var(--link-color-focus, var(--blue-9));
    font-weight: var(--link-font-weight-focus, var(--link-font-weight-default, normal));
    text-decoration: var(--link-text-decoration-focus, underline);
  }

  sl-dialog::part(panel) {
    border-radius: 7px;
    overflow: hidden;
  }
  sl-dialog::part(header) {
    background: var(--yellow-1);
    border-bottom: 1px solid var(--yellow-2);
    font-weight: 700;
  }
  sl-dialog::part(footer) {
    background: var(--gray-1);
    border-top: 1px solid var(--gray-3);
  }

  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border: none;

    --table-th-padding: var(--sl-spacing-small) var(--sl-spacing-medium);
    --table-cell-padding: var(--sl-spacing-small);
  }
  @media(min-width: 650px) {
    table {
      --table-cell-padding: var(--sl-spacing-medium);
    }
  }

  table th {
    text-align: left;

    padding: var(--table-th-padding);
    border-bottom: var(--table-th-border-bottom);
  }

  table td {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    padding: var(--table-cell-padding);
  }

  table td.icon-col {
    width: 1rem;
    font-size: 1.1rem;
    line-height: 1em;
    padding-right: 0;
  }
  table tr.completed td.icon-col {
    color: var(--green-6);
  }
  table tr.updated td.icon-col {
    color: var(--yellow-6);
  }
  table td.title-col {
    --link-color-default: var(--gray-8);
    --link-text-decoration-default: underline;
    --link-color-visited: var(--gray-7);
    --link-color-focus: var(--gray-9);
    --link-font-weight-default: 500;
  }
  table tr.completed td.title-col {
    --link-color-default: var(--green-7);
    --link-text-decoration-default: none;
    --link-color-visited: var(--green-7);
    --link-color-focus: var(--green-8);
    --link-font-weight-default: normal;
    font-style: italic;
  }
  table td.title-col a {
    text-wrap: wrap;
  }
  table td.time-col {
    width: 2rem;
    color: var(--gray-5);
    padding-left: 0;
  }
  table td.time-col sl-icon {
    margin-left: 0.5rem;
  }
  table td.time-col .duration {
    flex: 1 1 auto;
  }
  @media(min-width: 650px) {
    table td.time-col sl-icon {
      margin-left: 0;
    }
  }

  table td.version-col {
    width: 5rem;
    font-style: italic;
    display: none;
  }
  @media(min-width: 500px) {
    table td.version-col {
      display: table-cell;
    }
  }

  table td.action-col {
    width: 3rem;
    display: none;
  }
  @media(min-width: 650px) {
    table td.action-col {
      display: table-cell;
    }
  }

  table td .td-inner {
    display: flex;
    gap: 0.25rem;
    align-items: center;
    justify-content: flex-start;
  }

  table td .light {
    color: var(--gray-5);
  }

`;
